import { useCallback, useEffect, useState } from 'react';
import { useGetCurrentClientLocationMutation } from '~/client/hooks/geo/useCurrentClientLocation/GetCurrentClientLocationMutation.generated';
import useRouter from '~/client/hooks/router/useRouter';
import useIsRtl from '~/client/hooks/useIsRtl';
import useLanguage from '~/client/hooks/useLanguage';
import useCurrentUser from '~/client/hooks/user/useCurrentUser';
import useSite from '~/client/hooks/useSite';
import type { GeolocationIpCountries } from '~/schema/public';

const useOpenCommsParams = () => {
  const { user, profile } = useCurrentUser();
  const { code } = useLanguage();
  const { siteConfig } = useSite();
  const { asPath } = useRouter();
  const { isRtl } = useIsRtl();

  const [getCurrentClientLocation] = useGetCurrentClientLocationMutation();
  const [country, setCountry] = useState<GeolocationIpCountries>();

  useEffect(() => {
    const getClientLocation = async () => {
      const result = await getCurrentClientLocation();
      setCountry(result?.data?.geolocationGetCurrentClientLocation?.country);
    };
    getClientLocation();
  }, [getCurrentClientLocation]);

  const onChatFrameClosed = useCallback(() => {
    global?.webkit?.messageHandlers?.moonApp?.postMessage({
      message: 'close-comms-chat',
    });
    global?.native?.closeCommsChat();
  }, []);

  const commsPositionCss = {
    left: isRtl ? '20px' : 'auto',
    right: isRtl ? 'auto' : '20px',
  };

  const config = {
    ...siteConfig,
    commsConfig: {
      ...siteConfig.commsConfig,
      styles: {
        button: {
          ...commsPositionCss,
          ...siteConfig.commsConfig.styles?.button,
        },
        frame: { ...commsPositionCss, ...siteConfig.commsConfig.styles?.frame },
      },
    },
  };

  return {
    user,
    profile,
    code,
    siteConfig: config,
    isRtl,
    country,
    withOpenFrame: asPath === '/comms',
    onChatFrameClosed: asPath === '/comms' ? onChatFrameClosed : undefined,
  };
};

export default useOpenCommsParams;
